// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1gCn_","content":"LayoutSettings_content__3zsKz"};